// this is a port of the CS RingBuffer in aria-logger-net
// https://github.com/microsoft-notes/aria-logger-net/blob/master/Aria.Logger/RingBuffer.cs
export class RingBuffer<T> {
  readonly capacity: number
  private buffer: T[]
  private count: number
  private tailIndex: number

  constructor (capacity: number) {
    if (capacity <= 0) {
      throw new Error('Ring buffer capacity must be greater than zero')
    }
     this.capacity = capacity
     // tslint:disable-next-line:prefer-array-literal
     this.buffer = new Array<T>(capacity)
     this.tailIndex = capacity - 1
     this.count = 0
  }

  private getNextIndex =  (index: number): number =>
   (index + 1) % this.capacity

  public add (item: T) {
    this.tailIndex = this.getNextIndex(this.tailIndex)
    this.buffer[this.tailIndex] = item
    this.count = Math.min(this.capacity, this.count + 1)
  }

  public clear () {
    this.count = 0
    this.tailIndex = this.capacity - 1
    // tslint:disable-next-line:prefer-array-literal
    this.buffer = new Array<T>(this.capacity)
  }

  public toArray (): T[] {
    const arr: T[] = []
    if (this.count !== 0 ) {
      const startIndex = this.count === this.capacity
        ? this.getNextIndex(this.tailIndex)
        : 0

      for (let i = startIndex; i !== this.tailIndex; i = this.getNextIndex(i)) {
        if (this.buffer[i] !== undefined) {
          arr.push(this.buffer[i])
        }
      }
      if (this.buffer[this.tailIndex] !== undefined) {
        arr.push(this.buffer[this.tailIndex])
      }
    }
    return arr
  }
}